module.exports = __webpack_public_path__ + "1c593a568b347510402764c6b8e93a37.ttf";